export const NAMES = {
  TAG_NAME: "ab-user-reviews-list",
  EL_EMPTY:  "ab-user-reviews-empty",
  EL_LIST:  "ab-user-reviews",
  EL_ITEM:  "ab-user-review",
}